import React from 'react';
import { StaticImage } from 'gatsby-plugin-image';
import colorStyles from '@farmers-fridge/ui-library/dist/colors.module.css';
import Tag from '../../../tags/Tag';
import styles from './GrandOpeningBanner.module.css';

/**
 * @param {object} props
 * @param {string=} props.className
 * @param {string} props.color
 */
function Balloon({ className = '', color }) {
  return (
    <svg
      className={className}
      viewBox="0 0 106 269"
      xmlns="http://www.w3.org/2000/svg"
      type="presentation"
    >
      <path
        d="M53 122.37C53 147.338 37.4182 153.374 37.4182 180.701C37.4182 208.029 53 222.131 53 242.325C53.0549 251.27 52.0124 260.159 49.8727 268.83"
        stroke="#D8D8D8"
        fill="none"
        strokeWidth="4"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M106 53.0086C106 21.1815 82.2981 0 53 0C23.7019 0 0 21.1815 0 53.0086C0 80.1166 17.1729 109.584 40.2712 117.815C39.6128 118.419 39.119 119.077 38.735 119.901C38.3509 120.669 38.1863 121.547 38.1863 122.425C38.1863 124.071 38.8447 125.662 39.9969 126.815C41.1491 127.967 42.7402 128.626 44.3861 128.626H61.559C63.205 128.626 64.7961 127.967 65.9482 126.815C67.1004 125.662 67.7588 124.071 67.7588 122.425C67.7588 121.547 67.5393 120.724 67.2102 119.901C66.8261 119.132 66.3323 118.419 65.6739 117.815C88.7723 109.584 105.945 80.1166 105.945 53.0086H106Z"
        fill={color}
      />
      <path
        d="M90.6377 31.443C97.2216 41.9789 95.2464 60.5264 84.9866 65.52C74.7267 70.4587 61.998 59.0448 56.5663 47.9053C51.1346 36.7658 50.6408 27.3274 56.8406 21.8949C65.3447 14.3222 80.2133 14.8709 90.5828 31.4979L90.6377 31.443Z"
        fill={color}
      />
      <path
        d="M90.6377 31.443C97.2216 41.9789 95.2464 60.5264 84.9866 65.52C74.7267 70.4587 61.998 59.0448 56.5663 47.9053C51.1346 36.7658 50.6408 27.3274 56.8406 21.8949C65.3447 14.3222 80.2133 14.8709 90.5828 31.4979L90.6377 31.443Z"
        fill="white"
        fillOpacity="0.3"
      />
    </svg>
  );
}

/**
 * TODOs:
 *  - work on balloon positions
 */
export default function GrandOpeningBanner() {
  return (
    <div className={styles.wrapper}>
      <div className={styles.bgImageWrapper}>
        <StaticImage
          alt="Farmer's Fridge Salads on a table"
          aria-hidden="true"
          className={styles.bgImage}
          layout="fullWidth"
          loading="lazy"
          src="../../../../assets/img/promotional_banners/GrandOpeningSaladBG.jpg"
        />
      </div>
      <Balloon
        className={styles.balloon1}
        color={colorStyles.color_japanese_laurel}
      />
      <Balloon
        className={styles.balloon2}
        color={colorStyles.color_half_and_half}
      />
      <Balloon
        className={styles.balloon3}
        color={colorStyles.color_green_leaf}
      />
      <Balloon
        className={styles.balloon4}
        color={colorStyles.color_chrome_white}
      />
      <Balloon className={styles.balloon5} color={colorStyles.color_caper} />
      <Balloon
        className={styles.balloon6}
        color={colorStyles.color_chelsea_cucumber}
      />
      <div className={styles.textContent}>
        <svg className={styles.grandOpeningText} viewBox="0 0 300 106">
          <path id="curve" fill="transparent" d="M 0 106 Q 150 -40 300 106" />
          <text>
            <textPath
              startOffset="50%"
              dominantBaseline="middle"
              textAnchor="middle"
              xlinkHref="#curve"
              letterSpacing="1.5"
            >
              Grand Opening
            </textPath>
          </text>
        </svg>
        <h4 className={styles.subheader}>Enjoy</h4>
        <Tag
          className={styles.percentOffTag}
          fillColor={colorStyles.color_japanese_laurel}
          title="25% off Tag"
          height={38}
          width={110}
        >
          <h3 className={styles.percentOffSubheader}>25% Off</h3>
        </Tag>
        <h4 className={styles.subheader}>for a limited time</h4>
        <p className={styles.appPromoCaption}>
          Download our app or visit this fridge to experience this deal
        </p>
      </div>
    </div>
  );
}
